import useMemo from 'rc-util/lib/hooks/useMemo';
import shallowEqual from 'shallowequal';
export default function useTheme(theme, parentTheme) {
    const themeConfig = theme || {};
    const parentThemeConfig = parentTheme || {};
    const mergedTheme = useMemo(() => {
        if (!theme) {
            return parentTheme;
        }
        // Override
        const mergedOverride = Object.assign({}, parentThemeConfig.override);
        Object.keys(theme.override || {}).forEach((componentName) => {
            mergedOverride[componentName] = Object.assign(Object.assign({}, mergedOverride[componentName]), theme.override[componentName]);
        });
        // Base token
        const merged = Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), { token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token), override: mergedOverride });
        return merged;
    }, [themeConfig, parentThemeConfig], (prev, next) => prev.some((prevTheme, index) => {
        const nextTheme = next[index];
        return !shallowEqual(prevTheme, nextTheme);
    }));
    return mergedTheme;
}
